import { useState } from 'react';
import { format } from 'date-fns';
import { ko } from 'date-fns/locale';
// @mui
import {
  Dialog,
  DialogContent,
  DialogActions,
  Stack,
  Button,
  IconButton,
  Typography,
  TextField,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { DatePicker } from '@mui/x-date-pickers';
// hooks
import useGoals from '../../hooks/useGoals';
// components
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

export default function GoalAddDialog({ isOpen, closeDialog, companyId, onSuccess }) {
  const { createGoal } = useGoals(companyId);
  const [content, setContent] = useState('');
  const [dueDate, setDueDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setContent('');
    setDueDate(null);
    closeDialog();
  };

  const handleSubmit = async (e) => {
    if (e) e.stopPropagation();
    
    if (!content.trim()) return;
    if (!dueDate || isNaN(dueDate.getTime())) return;

    try {
      setIsLoading(true);
      await createGoal({
        content: content.trim(),
        due_date: dueDate ? format(dueDate, 'yyyy-MM-dd') : null,
      });
      // 성공적으로 추가되면 onSuccess 콜백 호출
      if (onSuccess) {
        onSuccess();
      } else {
        handleClose();
      }
    } catch (error) {
      console.error('Failed to create goal:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogContent sx={{ p: { xs: 3, sm: 4 }, pb: "0!important" }} dividers>
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
          <Typography variant="h5">회사의 요청사항을 등록해주세요.</Typography>
          <IconButton onClick={handleClose} edge="end">
            <Iconify icon="ic:close" />
          </IconButton>
        </Stack>
        <Stack spacing={3}>
          <Stack spacing={1}>
            <Typography variant="body2">
              회사와 DIO에 공유되며, 업무가 계획대로 진행되고 있는지 확인할 때 활용됩니다.
            </Typography>
          </Stack>

          <TextField
            fullWidth
            label="요청내용"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="예: 기능 개발 완료"
            autoFocus
          />
          
          <DatePicker
            label="기한"
            value={dueDate}
            onChange={setDueDate}
            renderInput={(params) => <TextField {...params} fullWidth />}
            inputFormat="yyyy-MM-dd"
            mask={"____-__-__"}
            disablePast
            locale={ko}
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ m: { xs: 0, sm: 1 } }}>
        <Button 
          onClick={(e) => {
            e.stopPropagation();
            handleClose();
          }} 
          color="inherit" 
          size="large" 
          sx={{ px: 4 }}
        >
          취소
        </Button>
        <LoadingButton
          size="large"
          sx={{ px: 4 }}
          loading={isLoading}
          onClick={(e) => handleSubmit(e)}
          variant="contained"
          disabled={!content.trim() || !dueDate}
        >
          등록하기
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
